import { render, staticRenderFns } from "./robikaMobilePreview.vue?vue&type=template&id=145d7735&scoped=true"
import script from "./robikaMobilePreview.vue?vue&type=script&lang=js"
export * from "./robikaMobilePreview.vue?vue&type=script&lang=js"
import style0 from "./robikaMobilePreview.vue?vue&type=style&index=0&id=145d7735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d7735",
  null
  
)

export default component.exports